import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { Circle } from './styles';

export default function Item({ title, description, icon }) {
  return (
    <Stack
      direction="row"
      gap="16px"
    >
      <Circle>
        <SharedAsset
          alt=""
          height={16}
          src={icon}
        />
      </Circle>
      <Stack gap="8px">
        <Text
          color="primary"
          size="xl"
          sx={(theme) => ({
            fontSize: 16,
            [theme.breakpoints.up('md')]: {
              fontSize: 22
            }
          })}
          weight="medium"
        >
          {title}
        </Text>
        <Text
          color="secondary"
          size="lg"
        >
          {description}
        </Text>
      </Stack>
    </Stack>
  );
}

Item.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired
};
